import * as t from '../actionTypes'
import axios from 'utils/axios'
import { guardFromErrors, extractErrorInfo } from 'utils/graphqlHelpers'
import { NginxSetting } from '../types'

type NginxSettingsList = {
  items: NginxSetting[]
  total: number
}

type Payload = NginxSettingsList & {
  page: number
}

export type FetchNginxSettingsListAction = FSA<undefined, Payload, string>
type FetchNginxSettingsList = () => MrxThunk<FetchNginxSettingsListAction>
type QueryResponse = GraphQLResponse<'nginxSettingsListPage', NginxSettingsList>

const FETCH_NGINX_SETTINGS_LIST = `
  query fetchNginxSettingsList ($page: Int, $size: Int, $filters: NginxSettingsFilters!) {
    nginxSettingsListPage(page: $page, size: $size, filters: $filters) {
      items {
        id
        name
        host
        port
        userName
        createdAt
        updatedAt
      }
      total
    }
  }
`

const fetchNginxSettingsList: FetchNginxSettingsList = () => async (dispatch, getState) => {
  dispatch({
    type: t.FETCH_NGINX_SETTINGS_LIST,
    meta: { done: false }
  })

  try {
    const {
      workspaces: {
        activeWorkspace: { id: workspaceId }
      },
      nginxSettings: {
        pagination: { currentPage: page, size }
      }
    } = getState()
    const {
      data: { data, errors }
    }: QueryResponse = await axios.post('/graphql', {
      query: FETCH_NGINX_SETTINGS_LIST,
      variables: { page, size, filters: { workspaceId } }
    })

    guardFromErrors(errors)

    if (!data) {
      throw new Error('Response body is empty!')
    }

    const { nginxSettingsListPage } = data
    if (!nginxSettingsListPage) {
      throw new Error("Can't get Nginx Settings list page!")
    }

    dispatch({
      type: t.FETCH_NGINX_SETTINGS_LIST,
      payload: {
        page,
        total: nginxSettingsListPage.total,
        items: nginxSettingsListPage.items
      },
      meta: { done: true }
    })
  } catch (err) {
    dispatch({
      type: t.FETCH_NGINX_SETTINGS_LIST,
      payload: extractErrorInfo(err),
      error: true
    })
  }
}

export { fetchNginxSettingsList }
